import React, { DragEvent, PropsWithChildren, useContext } from 'react';
import { Grid } from '@material-ui/core';
import AssignmentCard from './AssignmentCard';
import { useHistory } from 'react-router-dom';
import { teacherRoutes } from '../../../../../constants/routes';
import {
  DragAndDropContextActions,
  DragAndDropStore
} from '../context/DragAndDrop.context';

export interface AssignmentCardListProps {
  assignments: any[];
  userClasses: any[];
  handleAssign: (
    assignment: any,
    userClasses: any,
    dashboardUserId: number,
    assignmentId: number,
    isFromEdit: boolean
  ) => void;
}

const AssignmentCardList: React.FC<AssignmentCardListProps> = (
  props: PropsWithChildren<AssignmentCardListProps>
) => {
  const { assignments, userClasses } = props;
  const history = useHistory();
  const handleCard = (id: number, type: string) => {
    let query = '';
    if (type) {
      query = '?isPremade=true';
    }
    history.push(
      teacherRoutes.userGeneratedAssignmentsEdit.replace(
        ':id',
        (id as unknown) as string
      ) + query
    );
  };
  const { state: dragAndDropState, dispatch: dragAndDropDispatch } = useContext(
    DragAndDropStore
  );
  const { dragItem, dragNode } = dragAndDropState;

  /**
   * @description function fired when a folder starts dragging
   * @param evt
   * @param data
   */
  const onAssignmentDragStart = (evt: DragEvent<HTMLDivElement>, data: any) => {
    dragItem.current = { id: data.folderId };
    dragNode.current = evt.target;
    dragNode.current.addEventListener('dragend', onAssignmentDragEnd);

    dragAndDropDispatch({
      type: DragAndDropContextActions.SET_DRAG_ITEMS,
      payload: {
        dragItem,
        dragNode
      }
    });
  };

  /**
   * @description function fired when a folder stops dragging
   * @param evt
   */
  const onAssignmentDragEnd = (evt: React.DragEvent<HTMLDivElement>) => {
    dragItem.current = null;
    dragNode.current.removeEventListener('dragend', onAssignmentDragEnd);
    dragNode.current = null;
    dragAndDropDispatch({
      type: DragAndDropContextActions.SET_DRAG_ITEMS,
      payload: {
        dragItem,
        dragNode,
        highlightBreadCrumb: { id: null }
      }
    });
  };

  return (
    <Grid container spacing={2}>
      {/*
         Using component composition to render a custom card
      */}
      {props.children && (
        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
          {props.children}
        </Grid>
      )}
      {assignments.map((assignment: any) => {
        return (
          <Grid
            onClick={() => handleCard(assignment.id, assignment.type)}
            draggable={true}
            onDragStart={(evt: React.DragEvent<HTMLDivElement>) =>
              onAssignmentDragStart(evt, assignment)
            }
            key={assignment.id}
            style={{ cursor: 'pointer' }}
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            xl={2}
          >
            <AssignmentCard
              handleAssign={props.handleAssign}
              userClasses={userClasses}
              key={assignment.id}
              assignment={assignment}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default AssignmentCardList;
